module.exports = __webpack_public_path__ + "static/media/bored-weary.7d4af767.png";